import { EmailSignIn } from "./emailSignIn/EmailSignIn";
import { EmailSignUp } from "./emailSignUp/EmailSignUp";
import { SocialLogin } from "@/components/social-login/SocialLogin";
import useTranslation from "next-translate/useTranslation";
import Link from "next/link";
import type { FC } from "react";
import React, { useState } from "react";
import styles from "./Login.module.scss";
import { useLoginSearchParams } from "@/utils/hooks/useLoginSearchParams";
import classNames from "classnames";
import {
  PROFILE_SIGN_IN_ROUTE,
  PROFILE_SIGN_UP_ROUTE,
} from "@/constants/routes.constant";
import { LoginInfoBanner } from "./LoginInfoMessage/LoginInfoBanner";
import { LoginInfoDrawer } from "./LoginInfoMessage/LoginInfoDrawer";

export interface LoginProps {
  signIn?: boolean;
  isBigScreen: boolean;
}

const Login: FC<LoginProps> = ({ signIn = false, isBigScreen }) => {
  const { t } = useTranslation("web-payments");
  const loginSearchParams = useLoginSearchParams();
  const [isEmailFormExpanded, setIsEmailFormExpanded] = useState(false);

  const handleEmailClick = () => {
    setIsEmailFormExpanded(!isEmailFormExpanded);
  };

  return (
    <section className={styles.wrapper}>
      <div className={styles.formSection}>
        <div className={styles.formContentWrapper}>
          <h1 className={classNames(["title-3-regular", styles.title])}>
            {signIn ? t`SSO_SIGN_IN` : t`SSO_SIGN_UP`}
          </h1>
          <p className={classNames(["text-2", styles.subtitle])}>
            {signIn ? t`SSO_SIGN_IN_DESCRIPTION` : t`SSO_SIGN_UP_DESCRIPTION`}
          </p>
          <SocialLogin signIn onEmailClick={handleEmailClick} />
          <div
            className={classNames([
              styles.formWrapper,
              isEmailFormExpanded && styles.signupExpanded,
              isEmailFormExpanded && signIn && styles.expanded,
            ])}
          >
            {signIn ? <EmailSignIn /> : <EmailSignUp />}
          </div>
          <p className={styles.signInLink}>
            {!signIn && (
              <>
                {t`SSO_ACCOUNT_EXISTS`}{" "}
                <Link
                  href={`${PROFILE_SIGN_IN_ROUTE}?${loginSearchParams.toString()}`}
                >{t`LOGIN_LINK_SING_IN`}</Link>
              </>
            )}
            {signIn && (
              <>
                {t`LOGIN_NO_YET_ACCOUNT`}{" "}
                <Link
                  href={`${PROFILE_SIGN_UP_ROUTE}?${loginSearchParams.toString()}`}
                >{t`LOGIN_LINK_SIGN_UP`}</Link>
              </>
            )}
          </p>
        </div>
      </div>
      <section className={styles.copySection}>
        <div className={styles.copyContentWrapper}>
          <h2
            className={classNames([styles.title, styles.copyTitle])}
          >{t`BENEFITS_TITLE`}</h2>
          {isBigScreen ? <LoginInfoBanner /> : <LoginInfoDrawer />}
        </div>
      </section>
    </section>
  );
};

export { Login };
